export { default } from './SnapdocsQualityControlBlock';
